import React, { useState } from "react";
import PropTypes from "prop-types";
import Collapsible from "../../../components/collapsible/Collapsible";

const CollapsibleInfoItem = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded((prevState) => !prevState);
  };

  const shouldShowReadMore = (content) => {
    return content.full.length > 150;
  };

  return (
    <div className="row mb-3">
      <div className="column col-md-12 col-lg-12 col-xl-9 px-4 py-4 border rounded-1 w-100">
        <Collapsible
          title={<p className="fs-6 mb-0 font-error">{title}</p>}
          expanded={isExpanded}
          isErrorInfo={true}
          isEligibility={true}
        >
          <div className="d-flex mt-0 align-items-center justify-content-between text-medium-gray">
            <p className="mb-0 text-dark-6">
              {isExpanded ? content.full : content.short}
              {shouldShowReadMore(content) && (
                <span
                  className="read-more-link text-primary-600 text-decoration-none"
                  onClick={handleToggle}
                >
                  {isExpanded ? " Read less" : " Read more"}
                </span>
              )}
            </p>
          </div>
        </Collapsible>
      </div>
    </div>
  );
};

CollapsibleInfoItem.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.shape({
    full: PropTypes.string.isRequired,
    short: PropTypes.string.isRequired,
  }).isRequired,
};

export default CollapsibleInfoItem;
